import { useEffect } from "react";
import { getXAPITracker } from "../../services/xapi-tracking";

export const TrackingServiceWrapper = ({ currentUser, children }) => {
  const xApiTrackingService = getXAPITracker();

  useEffect(() => {
    // Only configure if the service hasn't been initialized yet
    if (!xApiTrackingService._initialized && currentUser) {
      xApiTrackingService.configure(currentUser);
    }
  }, [currentUser, xApiTrackingService]);

  return children;
};
